import { message } from 'antd'
import { saveAuditData } from 'src/api/audit'
import { fetchUtil as fetch } from 'src/utils/fetch'

export const getEvents = async () => {
  try {
    const { data } = await fetch('/metaverse-rooms/game-events', {
      headers: {
        role: 'ADMIN',
      },
    })

    return data
  } catch (e) {
    message.error('Get Game Events error!')
  }
}

export const getEventsByCountry = async (country) => {
  try {
    const { data } = await fetch(
      `/metaverse-rooms/game-events/provider-country/${country}`,
      {
        headers: {
          role: 'ADMIN',
        },
      }
    )
    return data
  } catch (e) {
    message.error('Get Game Events Country error!')
  }
}

export const eventRedeemCode = async (eventId, redeemCode) => {
  try {
    await fetch(
      `/metaverse-rooms/game-events/${eventId}/redeem/code/${redeemCode}`,
      {
        method: 'PUT',
        headers: {
          role: 'ADMIN',
        },
      }
    )
    return { success: true }
  } catch (e) {
    return { success: false, error: e }
  }
}

export const getTopScorersEvent = async (eventId) => {
  try {
    const { data } = await fetch(
      `/metaverse-rooms/game-events/${eventId}/top/admin?page=0&size=30`
    )
    return data
  } catch (e) {
    console.log('Error getTopScorersEvent', e)
  }
}

export const getEventDayPrices = async (eventId, day) => {
  try {
    const params = new URLSearchParams()

    if (day !== null && day !== undefined && day !== '') {
      params.append('day', day)
    }

    const query = params.toString()
    const url = `/metaverse-rooms/game-events/event-day/${eventId}${
      query ? `?${query}` : ''
    }`
    const { data } = await fetch(url)

    return data
  } catch (e) {
    console.log('Error getEventDayPrices', e)
  }
}

export const saveEditMarketplace = async (
  id,
  name,
  points,
  description,
  images
) => {
  if (points == undefined || points === null || points === '') {
    points = 0
  }
  try {
    const input = new FormData()
    input.append(
      'marketPlaceDto',
      new Blob(
        [
          JSON.stringify({
            id: id,
            name: name,
            points: points,
            description: description,
            providerCountry: 'IN',
          }),
        ],
        {
          type: 'application/json',
        }
      )
    )
    if (images.length > 0) {
      for (let i = 0; i < images.length; i++) {
        input.append('images', images[i])
      }
    }

    await fetch('/marketplace/prices/edit', {
      method: 'POST',
      body: input,
      headers: {
        role: 'ADMIN',
      },
    })
    saveAuditData('EVENT-EDIT', 'MARKETPLACE', name)
    message.success('Success Marketplace Edit!')
    return 'success'
  } catch (e) {
    message.error('Edit Marketplace error!')
    return 'failed'
  }
}
